<template>
    <div>
        <v-flex pl-2 class="speaker-resource">
            <v-layout
                row
                wrap
                class="speaker-resource__applicants__header">
                <v-flex
                    xs12
                    sm6
                    lg8>
                    <v-flex tag="h2">{{SpeakerApplicants.REVIEWED_APPLICANTS}}</v-flex>
                </v-flex>
                <v-flex
                    xs12
                    sm6
                    lg4
                    text-sm-right
                    pl-4
                    class="showing-status-xs">
                    <v-flex><span>{{SpeakerApplicants.SHOWING}}</span>
                        <v-select
                            data-qe-id="review_approve_deny_select"
                            :items="SpeakerApplicants.STATUS_ITEMS"
                            v-model="selectedStatus"
                            solo
                            flat
                            hide-details
                            @change="StatusChange"></v-select>
                    </v-flex>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex lg12 xs12>
                    <v-flex class="speaker-resource__applicants relative-position">
                         <status-overlay :action="loadingAction"
                                         content-height="400px"
                                         v-if="reviewedApplicants && !reviewedApplicants.length"></status-overlay>
                        <v-flex class="applicants-list">
                            <div v-infinite-scroll="getInfiniteReviewedApplicants" :infinite-scroll-distance="2000">
                                <v-layout
                                    row
                                    wrap
                                    class="applicants-list__row"
                                    v-for="(reviewedApplicant,i) in reviewedApplicants"
                                    :key="i"
                                    @click="openSpeakerProfile(reviewedApplicant)">
                                    <v-flex
                                        xs12
                                        sm8
                                        md9
                                        class="user-info"
                                        :class="reviewedApplicant.approvalStatus === 'R' ? '': 'pointer'"
                                        :data-qe-id="'reviewed_applicant'+ i">
                                        <img :data-qe-id="`speaker-reviewed-applicants-${i}_profile-image`" :onerror="imageErrorFallback(reviewedApplicant.fallbackProfileImageUrl)" :src="reviewedApplicant.profileImageUrl === null ? reviewedApplicant.fallbackProfileImageUrl : reviewedApplicant.profileImageUrl" />
                                        <strong :data-qe-id="'reviewed_first_last_name'+ i">{{reviewedApplicant.firstName}} {{reviewedApplicant.familyName}}</strong>
                                        <small :data-qe-id="'reviewed_travels_from'+ i">Travels from: {{reviewedApplicant.travelFromCity}}, {{reviewedApplicant.country}}</small>
                                        <span :data-qe-id="'reviewed_travels_from'+ i">Fees: <em>{{reviewedApplicant.feeRange}}</em></span>
                                        <span :data-qe-id="'reviewed_categories'+ i">{{SpeakerApplicants.CATEGORIES}} <em :data-qe-id="'reviewed_categories_first'+ i"> {{reviewedApplicant.categories[0]}}</em> <em :data-qe-id="'reviewed_categories_count'+ i" class="pl-2" v-if="reviewedApplicant.categories.length >1">{{`+${reviewedApplicant.categories.length-1}`}} </em></span>
                                    </v-flex>
                                    <v-flex
                                        xs12
                                        sm4
                                        md3
                                        pr-2
                                        text-xs-right
                                        class="user-status">
                                        <span class="approved" v-if="reviewedApplicant.approvalStatus === 'A'">{{SpeakerApplicants.APPROVED}} </span>
                                        <span class="denied" v-if="reviewedApplicant.approvalStatus === 'R'">{{SpeakerApplicants.DENIED}} </span>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </v-flex>
                    </v-flex>
                </v-flex>
            </v-layout>
        </v-flex>
        <BacktoTop></BacktoTop>
    </div>
</template>

<script>
    import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeMutation } from "../../store/storeMutations.constant";
    import { imageErrorFallback } from "../../common/utils/utils";
    import { SpeakerApplicants } from "../Speakers/speakerConstant";
    import BacktoTop from '../../components/Layout/BackToTop';
    import StatusOverlay from "../StatusOverlay/StatusOverlay";

    export default {
        name: "SpeakerReviewedApplicants",
        data: () => ({
            SpeakerApplicants,
            selectedStatus: SpeakerApplicants.STATUS_ITEMS[2],
        }),

        components: {
            StatusOverlay,
            BacktoTop,
        },
        created() {
            this.resetReviewedApplicantsList();
            this.getReviewedApplicants(null);
        },

        methods: {
            ...mapActions({
                getReviewedApplicants: `speaker/${storeAction.getReviewedApplicants}`,

            }),
            ...mapMutations({
                resetReviewedApplicantsList: `speaker/${storeMutation.resetReviewedApplicantsList}`,
                setSpeakerStatus: `speaker/${storeMutation.setSpeakerStatus}`,
                setCurrentlyViewingPendingOrReviewApplicantRecord: `speaker/${storeMutation.setCurrentlyViewingPendingOrReviewApplicantRecord}`,
            }),

            imageErrorFallback,
            StatusChange(status) {
                this.resetReviewedApplicantsList();
                if (status === SpeakerApplicants.STATUS_ITEMS[0]) {
                    this.getReviewedApplicants("A");
                } else if (status === SpeakerApplicants.STATUS_ITEMS[1]) {
                    this.getReviewedApplicants("R");
                } else { this.getReviewedApplicants(null); }
            },
            getInfiniteReviewedApplicants() {
                if (!this.disableRAInfiniteScroll && !this.noMoreReviewedApplicantsToFetch) {
                    if (this.selectedStatus === SpeakerApplicants.STATUS_ITEMS[0]) {
                        this.getReviewedApplicants("A");
                    } else if (this.selectedStatus === SpeakerApplicants.STATUS_ITEMS[1]) {
                        this.getReviewedApplicants("R");
                    } else { this.getReviewedApplicants(null); }
                }
            },

            openSpeakerProfile(approveApplicant) {
                if (approveApplicant.approvalStatus === "A") {
                    const speakerType = approveApplicant.speakerType === 'Non-Member' ? 'speaker' : 'member';
                    const id = approveApplicant.speakerType === "Non-Member" ? approveApplicant.speakerId : approveApplicant.personID;
                    sessionStorage.removeItem(SpeakerApplicants.SPEAKER_TYPE);
                    sessionStorage.removeItem(SpeakerApplicants.SPEAKER_STATUS);
                    sessionStorage.setItem(SpeakerApplicants.PREVIOUS_PAGE, 'Reviewed');
                    sessionStorage.setItem(SpeakerApplicants.SPEAKER_TYPE, speakerType);
                    sessionStorage.setItem(SpeakerApplicants.SPEAKER_STATUS, 'A');

                   this.setCurrentlyViewingPendingOrReviewApplicantRecord({ recordType: 'reviewed', speakerType, id });
                    this.$router.push({
                        path: `/speakerPage/speakerProfile`,
                        query: {
                            id,

                        },
                    });
                }
            },
        },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
                reviewedApplicants: `speaker/${storeGetters.reviewedApplicants}`,
                disableRAInfiniteScroll: `speaker/${storeGetters.disableRAInfiniteScroll}`,
                noMoreReviewedApplicantsToFetch: `speaker/${storeGetters.noMoreReviewedApplicantsToFetch}`,
            }),
            loadingAction() {
                return this.actions[storeAction.getReviewedApplicants];
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .speaker-resource {
        &__options {
            &__row {
                border-bottom: 1px solid rgba($ypo-gray, 0.4);
                padding: 15px;
                position: relative;
                color: $ypo-blue;
                cursor: pointer;
                transition: all .3s ease;

                i {
                    font-size: 20px;
                    margin-right: 5px;
                }

                &:hover {
                    background: rgba($ypo-gray, 0.1);
                    text-shadow: 0 1px $ypo-blue;
                }
            }
        }

        &__applicants {
            position: relative;

            &__header {
                padding: 15px 0;
                border-bottom: 1px solid rgba($ypo-gray, 0.4);
                align-items: center;
                color: $ypo-blue;

                h2 {
                    font-family: 'Raleway', sans-serif;
                    font-size: 18px;
                    font-weight: 500;
                }

                span {
                    font-size: 14px;
                }
            }
        }

        .applicants-list {
            &__row {
                padding: 15px 10px;
                border-bottom: 1px solid rgba($ypo-gray, 0.4);
                align-items: center;
                transition: all .3s ease;

                &:hover {
                    background-color: rgba($ypo-gray, 0.1);
                }

                .user-info {
                    position: relative;
                    padding-left: 80px;
                    color: $ypo-blue;
                    font-size: 10px;

                    img {
                        width: 70px;
                        height: 70px;
                        position: absolute;
                        left: 0;
                        object-fit: contain;
                    }

                    strong {
                        display: block;
                        color: $ypo-dark-background-gray;
                        font-size: 16px;
                    }

                    small {
                        display: block;
                        font-size: 10px;
                        font-weight: bold;
                    }

                    span {
                        display: block;
                        font-weight: 600;

                        em {
                            font-style: normal;
                            color: $ypo-dark-background-gray;
                        }
                    }
                }

                .user-status {
                    text-transform: uppercase;
                    font-weight: 600;

                    .approved {
                        color: $ypo-medium-green;
                    }

                    .denied {
                        color: $ypo-red;
                    }
                }

                .user-status {
                    text-transform: uppercase;
                    font-weight: 600;

                    .approved {
                        color: $ypo-medium-green;
                    }

                    .denied {
                        color: $ypo-red;
                    }
                }

            }
        }

        @include breakpoint(xs) {
            &__applicants {
                &__header {
                    .showing-status-xs {
                        padding-left: 0 !important;

                        .v-text-field {
                            width: 64%;
                        }
                    }
                }
            }
        }
    }
</style><style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .speaker-resource {
        &__applicants {
            &__header {
                .v-text-field {
                    width: 75%;
                    display: inline-block;

                    .v-select__selection {
                        color: $ypo-cta;
                        font-size: 14px;
                    }

                    .v-input__control {
                        min-height: inherit;
                    }
                }

                span {
                    font-weight: 600;
                }
            }
        }
    }
</style><style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .speaker-resource {
        &__applicants {
            &__header {
                .v-text-field {
                    width: 75%;
                    display: inline-block;

                    .v-select__selection {
                        color: $ypo-cta;
                        font-size: 14px;
                    }
                }

                span {
                    font-weight: 600;
                }
            }
        }
    }
</style>
